module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [(_vm.showGo) ? _c('a', {
    staticClass: "button button-link button-nav pull-left",
    on: {
      "click": function($event) {
        return _vm.gotolast()
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("返回\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "content-inner"
  }, [_c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "0"
    }
  }, [_c('ul', [_c('div', {
    staticClass: "orderTitle"
  }, [_vm._v("填写订单")]), _c('div', {
    staticClass: "blueTitle"
  }), _vm._v(" "), _c('li', {
    staticClass: "orderInfo"
  }, [_vm._v("收货地址")]), _vm._v(" "), _vm._l((_vm.filterAddress), function(address, index) {
    return _c('li', [_c('router-link', {
      staticClass: "item-link item-content",
      attrs: {
        "to": {
          name: 'address',
          params: {
            order: _vm.order
          }
        }
      }
    }, [_c('div', {
      staticClass: "item-inner",
      staticStyle: {
        "padding": "0 0 0 2rem"
      }
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(address.consignee))])]), _vm._v(" "), _c('div', {
      staticClass: "item-subtitle"
    }, [_vm._v(_vm._s(address.expressAddress))]), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_vm._v(_vm._s(address.expressMobile))])])])], 1)
  }), _vm._v(" "), _c('li', {
    staticClass: "orderInfo"
  }, [_c('span', [_vm._v("订单信息")]), _vm._v(" "), _c('a', {
    staticClass: "alert-text",
    on: {
      "click": function($event) {
        return _vm.displayMessage1()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": ".9rem"
    },
    attrs: {
      "src": _vm.questionUrl
    }
  })])])], 2)]), _vm._v(" "), _vm._l((_vm.orderList), function(merchandise) {
    return _c('div', {
      staticClass: "list-block media-list",
      staticStyle: {
        "margin": "5px 5% 0 5%",
        "width": "90%"
      }
    }, [_c('ul', [_c('li', [_c('a', {
      staticClass: "item-link item-content",
      on: {
        "click": function($event) {
          return _vm.goToDetail(merchandise)
        }
      }
    }, [_c('div', {
      staticClass: "item-media"
    }), _vm._v(" "), _c('div', {
      staticClass: "item-inner"
    }, [_c('div', {
      staticStyle: {
        "margin-top": "1rem",
        "border-bottom": "1px solid #1a1a1a",
        "padding-top": "0.5rem"
      }
    }, [_c('div', {
      staticStyle: {
        "border": "#2ac845",
        "padding-bottom": ".5rem"
      }
    }, [_vm._l((merchandise._subTitleList), function(subTitle) {
      return (merchandise._subTitleList && merchandise._subTitleList.length > 0) ? _c('span', [_c('span', {
        staticStyle: {
          "position": "relative",
          "color": "white",
          "background-color": "white",
          "padding": "0.1rem"
        }
      }), _vm._v(" "), (subTitle.valueText !== '-1' && subTitle.value !== '-1') ? _c('span', {
        staticStyle: {
          "font-size": "0.7rem",
          "color": "white",
          "background-color": "#00469A",
          "padding": "0.1rem"
        }
      }, [_vm._v(_vm._s(subTitle.valueText))]) : _vm._e()]) : _vm._e()
    }), _vm._v(" "), _vm._l((merchandise._abstractList), function(abstractTitle) {
      return (merchandise._abstractList && merchandise._abstractList.length > 0) ? _c('span', {
        staticStyle: {
          "font-size": "0.9rem",
          "color": "black"
        }
      }, [(abstractTitle.valueText !== '-1' && abstractTitle.value !== '-1') ? _c('span', [(abstractTitle.columnName === 'TVInfo' && abstractTitle.valueText.TLNo !== undefined) ? _c('span', [_vm._v(_vm._s(abstractTitle.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstractTitle.valueText))])]) : _vm._e()]) : _vm._e()
    })], 2), _vm._v(" "), _vm._l((merchandise._titleList), function(title) {
      return (merchandise._titleList && merchandise._titleList.length > 0) ? _c('span', {
        staticStyle: {
          "left": "0",
          "bottom": "0",
          "font-size": "1.2rem",
          "color": "#3F3F3F",
          "padding": "0.2rem 0 0.2rem 0",
          "font-weight": "bold"
        }
      }, [(title.valueText !== '-1' && title.value !== '-1') ? _c('span', [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))])]) : _vm._e()]) : _vm._e()
    }), _vm._v(" "), (merchandise.selfOperated === 0) ? _c('div', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "x-small",
        "color": "#1482E7"
      }
    }, [_vm._v("【代购】")])]) : _vm._e()], 2), _vm._v(" "), (merchandise.discountPrice && merchandise.discountPrice !== 0 && !_vm.isUseSpecialFundCoupon) ? _c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title",
      staticStyle: {
        "color": "#6e727b"
      }
    }, [_vm._v("折扣")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "color": "#00469A",
        "font-size": "0.1rem"
      },
      attrs: {
        "lass": "item-after"
      }
    }, [_vm._v(" ￥"), _c('span', {
      staticStyle: {
        "font-size": "1.3rem"
      }
    }, [_vm._v(_vm._s(merchandise.discountPrice) + " ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "item-title-row"
    }, [(!merchandise.productQuantity && merchandise.quantity === 0) ? _c('div', {
      staticClass: "item-title",
      staticStyle: {
        "color": "#6e727b"
      }
    }, [_vm._v("合计1个产品")]) : _c('div', {
      staticClass: "item-title",
      staticStyle: {
        "color": "#6e727b"
      }
    }, [_vm._v("合计" + _vm._s(merchandise.productQuantity ? merchandise.productQuantity : merchandise.quantity) + "个产品")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "color": "#00469A",
        "font-size": "0.1rem"
      },
      attrs: {
        "lass": "item-after"
      }
    }, [_vm._v("\n                    ￥"), (_vm.isSFFlag) ? _c('span', {
      staticStyle: {
        "font-size": "1.3rem"
      }
    }, [_vm._v(_vm._s(merchandise.priceMax) + " ")]) : (merchandise.price && merchandise.price !== 0) ? _c('span', {
      staticStyle: {
        "font-size": "1.3rem"
      }
    }, [_vm._v(_vm._s(merchandise.price) + " ")]) : (merchandise.priceMin) ? _c('span', {
      staticStyle: {
        "font-size": "1.3rem"
      }
    }, [_vm._v(_vm._s(merchandise.priceMin) + " ")]) : _c('span', {
      staticStyle: {
        "font-size": "1.3rem"
      }
    }, [_vm._v(_vm._s(merchandise.priceMax) + " ")])])])])])])])])
  }), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "10px",
      "font-size": "14PX"
    }
  }, [_c('ul', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title",
    staticStyle: {
      "padding-left": "1rem"
    }
  }, [_vm._v("\n                    选择不发货\n                      "), _c('a', {
    staticClass: "alert-text",
    on: {
      "click": _vm.displayMessage
    }
  }, [_c('img', {
    staticStyle: {
      "width": "1.4rem",
      "padding-left": ".3rem"
    },
    attrs: {
      "src": _vm.questionUrl
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-right": "1rem"
    },
    attrs: {
      "lass": "item-after"
    }
  }, [_c('div', [_c('label', {
    staticClass: "label-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isExpress),
      expression: "isExpress"
    }],
    attrs: {
      "id": "express",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isExpress) ? _vm._i(_vm.isExpress, null) > -1 : (_vm.isExpress)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.isExpress,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isExpress = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isExpress = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isExpress = $$c
        }
      }, _vm.changeExpressFree]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])])])]), _vm._v(" "), (_vm.isSFFlag && !_vm.isUseSpecialFundCoupon) ? _c('div', {
    staticClass: "item-title-row",
    staticStyle: {
      "margin-bottom": "8px",
      "margin-top": "8px"
    }
  }, [_c('div', {
    staticClass: "item-title",
    staticStyle: {
      "padding-left": "1rem"
    }
  }, [_vm._v("\n                    不使用优惠券\n                  ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-right": "1rem"
    },
    attrs: {
      "lass": "item-after"
    }
  }, [_c('div', [_c('label', {
    staticClass: "label-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.couponRefused),
      expression: "couponRefused"
    }],
    attrs: {
      "id": "coupon_refused",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.couponRefused) ? _vm._i(_vm.couponRefused, null) > -1 : (_vm.couponRefused)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.couponRefused,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.couponRefused = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.couponRefused = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.couponRefused = $$c
        }
      }, _vm.changeCouponRefused]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title",
    staticStyle: {
      "padding-left": "1rem"
    }
  }, [_vm._v("商品金额")]), _vm._v(" "), _c('div', {
    staticClass: "item-after",
    staticStyle: {
      "padding-right": "1rem",
      "color": "#00469A"
    }
  }, [_c('span', {
    staticClass: "expressPrice"
  }, [_vm._v("￥")]), _vm._v(" "), _c('span', {
    staticClass: "expressMoney"
  }, [_vm._v(_vm._s(_vm.goodsMoney))])])]), _vm._v(" "), (_vm.discountPrice && !_vm.isUseSpecialFundCoupon) ? _c('div', {
    staticClass: "item-title-row"
  }, [_c('div', {
    staticClass: "item-title",
    staticStyle: {
      "padding-left": "1rem"
    }
  }, [_vm._v("折扣")]), _vm._v(" "), _c('div', {
    staticClass: "item-after",
    staticStyle: {
      "padding-right": "1rem",
      "color": "#00469A"
    }
  }, [_c('span', {
    staticClass: "expressPrice"
  }, [_vm._v("-￥")]), _vm._v(" "), _c('span', {
    staticClass: "expressMoney"
  }, [_vm._v(_vm._s(_vm.discountPrice))])])]) : _vm._e(), _vm._v(" "), (_vm.expressPrice && _vm.expressPrice > 0) ? _c('div', {
    staticClass: "item-title-row",
    staticStyle: {
      "margin-bottom": "1rem"
    }
  }, [_c('div', {
    staticClass: "item-title",
    staticStyle: {
      "padding-left": "1rem"
    }
  }, [_vm._v("\n                    运费\n                    "), _c('a', {
    staticClass: "alert-text",
    on: {
      "click": function($event) {
        return _vm.displayMessage2()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "1.4rem",
      "padding-left": ".3rem"
    },
    attrs: {
      "src": _vm.questionUrl
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item-after",
    staticStyle: {
      "padding-right": "1rem",
      "color": "#00469A"
    }
  }, [_c('span', {
    staticClass: "expressPrice"
  }, [_vm._v("+￥")]), _vm._v(" "), _c('span', {
    staticClass: "expressMoney"
  }, [_vm._v(_vm._s(_vm.expressPrice))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "1.2rem"
    }
  })])])])])], 2)]), _vm._v(" "), _c('footer', {
    staticClass: "bar  bar-tab",
    staticStyle: {
      "height": "3rem"
    }
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('div', {
    staticClass: "tab-item"
  }, [_c('span', {
    staticClass: "tab-label"
  }, [_vm._v("实支付")]), _vm._v(" "), _c('span', {
    staticClass: "expressPrice",
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("￥")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "1.3rem",
      "color": "black"
    }
  }, [_vm._v(_vm._s(_vm.totalMoney.toFixed(2)))]), _vm._v(" "), _c('section', [(_vm.showButton && _vm.showBtn) ? _c('span', {
    staticClass: "buttonStyle",
    on: {
      "click": _vm.response
    }
  }, [_vm._v(_vm._s(_vm.buttonName))]) : _c('span', {
    staticClass: "buttonStyle",
    staticStyle: {
      "background-color": "gainsboro"
    }
  }, [_vm._v(_vm._s(_vm.buttonName))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f6b7e9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/Order/child/Order.vue
// module id = 1670
// module chunks = 8